import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import './css/app.css'
import './css/index.css';
import App from './pages/app';
import Brand from './pages/brand';
import Faq from './pages/faq';
import Rice from './pages/rice';
import Veg from './pages/veg';
import Order from './pages/order';
import NoMatch from './pages/nomatch';



class Pages extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            context: {}
        }
    }

    componentWillMount() {
        let __self = this;
        let noteId = "";
        let search = window.location.search;
        if (search !== undefined && search !== "" && search.indexOf("?") !== -1) {
            let params = this.getUrlParams();
            if (params.noteId !== undefined && params.noteId !== "") {
                console.log("params.noteId: " + params.noteId)
                noteId = params.noteId;
            }
        }

        if (noteId === "") {
            noteId = "5722639";
        }
        
        let url = window.location.protocol + "//store.tagfans.com/node/getNote?noteId=" + noteId;
        window.$.ajax({
            url: url,
            success:function(json){
                console.log(" == context ==");
                console.log(json);
                __self.setState({context: json})
            },
            error: function(err) {
                console.log("error");
                console.log(err);
            }
          });
    }


    getUrlParams = () => {
        let args = {};
        let params = window.location.href.split("?");
        if (params.length !== 0 && params[1] !== undefined) {
            var parameters = params[1].split("&");
            for (var i = 0; i < parameters.length; i++) {
                let p = parameters[i].split("=");
                args[p[0]] = p[1];
            }
        }
        
        return args
    }


    render() {

        const { history } = this.props;
        console.log("history0:", history)
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path='/' component={() => <App context={this.state.context} />} />
                        <Route path='/index.html' component={() => <App context={this.state.context} />} />
                        <Route path='/about' component={() => <Brand context={this.state.context} />} />
                        <Route path='/faq/:id' component={() => <Faq context={this.state.context} />} />
                        <Route path='/faq' component={() => <Faq context={this.state.context} />} />
                        <Route path='/rice' component={() => <Rice context={this.state.context} />}/>
                        <Route path='/veg' component={() => <Veg context={this.state.context} />} />
                        <Route path='/order' component={() => <Order context={this.state.context} />}/>
                        {/* when none of the above match, <NoMatch> will be rendered */}
                        <Route component={NoMatch} />
                    </Switch>
                </div>
            </Router>
        )
    }

}



ReactDOM.render(<Pages />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js